module.exports = __webpack_public_path__ + "static/media/ibd_neck1.91497999.png";